import React, { useEffect, useRef, useState } from "react";
import SearchForm from "../../../component/search-form";
import {
  booking_constant,
  purchase_constants,
  sales_constants,
  todo_constants,
} from "./helper";
import { useDispatch, useSelector } from "react-redux";
import { getBookingFieldList } from "../../../redux/actions/booking";
import {
  getToDoById,
  getTodoCustomFieldList,
} from "../../../redux/actions/todo";
import { useFormik } from "formik";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../../component/modal-popup/customeModal";

import { useQuill } from 'react-quilljs';
import Quill from 'quill';
import 'quill/dist/quill.snow.css';
import 'quill-mention/dist/quill.mention.css';
import { Mention, MentionBlot } from 'quill-mention';
import "./helper/quill.css";
// import QuillBetterTable from "quill-better-table";
// import "quill-better-table/dist/quill-better-table.css";


const EmailComposer = ({ isOpen, setIsOpen, todo_id, _handleSubmit, emailData }) => {
  const dispatch = useDispatch();
  const [search, setSearch] = useState("");
  const [activeField, setActiveField] = useState(null);
  const [bookingData, setBookingData] = useState([]);
  const [todoData, setTodoData] = useState([]);
  const [toodAttchment, setTodoAttachment] = useState(false);
  const { bookingFieldList } = useSelector((state) => state.booking);
  const { todoFieldList, todoDataByToDoId } = useSelector(
    (state) => state.todo
  );

  const body_ref = useRef([]);

  const { quill, quillRef } = useQuill({
    theme: "snow",
    modules: {
      toolbar: {
        container: [
          ["undo", "redo"],
          // [{ font: [] }],
          [{ size: [] }],
          ["bold", "italic", "underline"],
          [{ list: "ordered" }, { list: "bullet" }],
          [{ align: [] }],
          ["link"],
          // [{ table: true }]
        ],
        // handlers: {
        //   table: function () {
        //     if (quillRefInstance.current) {
        //       const tableModule = quillRefInstance.current.getModule("better-table");
        //       console.log("🚀 ~ quill.getModule ~ tableModule:", tableModule)
        //       if (tableModule) {
        //         const range = quillRefInstance.current.getSelection();
        //         if (range) {
        //           console.log("Inserting table...");
        //           tableModule.insertTable(3, 3, range.index); // Insert 3x3 table
        //         }
        //       }
        //     }
        //   },
        // }
      },
      mention: {
        allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
        mentionDenotationChars: ["{{"],
        source: (searchTerm, renderList) => {
          if(searchTerm?.length >= 2){
            const list  = [...bookingData, ...todoData].map((item, index) => ({ value: item.label, id: item.key }))
            const matches = list.filter((user) =>
              user.value.toLowerCase().includes(searchTerm.toLowerCase())
            );
  
            renderList(matches);
          }
        },
        onSelect: (item, insertItem) => {
          if (quillRefInstance.current) {
            const range = quillRefInstance.current.getSelection();
            if (!range) return;

            let mentionStart = range.index - 2;
            while (mentionStart > 0) {
              const char = quillRefInstance.current.getText(mentionStart - 2, 2);
              if (char === '{{') {
                break;
              }
              mentionStart--;
            }
            quillRefInstance.current.deleteText(mentionStart, range.index - mentionStart);
            const mentionText = `${item.id}}} `;
            quillRefInstance.current.insertText(mentionStart, mentionText);
            quillRefInstance.current.setSelection(mentionStart + mentionText.length);
            body_ref.current.push({
              label: item.value,
              key: item.id
            })
          }
        }        
      },
      // "better-table": {
      //   operationMenu: {
      //     items: {
      //       unmergeCells: { text: "Unmerge Cells" },
      //     },
      //   },
      // },
    },
  });

  let defaultValues = {
    use_custom_notification: emailData?.use_custom_notification
      ? emailData.use_custom_notification
      : false,
    subject: emailData?.subject ? emailData?.subject : "",
    subject_obj: emailData?.subject_obj
      ? typeof emailData.subject_obj === "object"
        ? emailData.subject_obj
        : JSON.parse(emailData.subject_obj || "[]")
      : [],
    body: emailData?.body ? emailData?.body : "",
    body_obj: emailData?.body_obj
      ? typeof emailData.body_obj === "object"
        ? emailData.body_obj
        : JSON.parse(emailData.body_obj || "[]")
      : [],
    attach_booking_documents: emailData?.attach_booking_documents
      ? emailData.attach_booking_documents
      : false,
    attach_todo_documents: emailData?.attach_todo_documents
      ? typeof emailData?.attach_todo_documents === "object"
        ? emailData?.attach_todo_documents
        : JSON.parse(emailData?.attach_todo_documents || "[]")
      : [],
  };

  const quillRefInstance = useRef(null);
  const subjectRef = useRef(null);

  useEffect(() => {
    Quill.register('modules/mention', Mention);
    Quill.register("formats/mention", MentionBlot, true)
    // Quill.register("modules/better-table", QuillBetterTable, true);
  }, [])

  useEffect(() => {
    dispatch(getBookingFieldList());
    dispatch(getTodoCustomFieldList(todo_id));
    dispatch(getToDoById(todo_id, () => {}));
  }, []);

  useEffect(() => {
    let bookingTempList = [...booking_constant];

    if (todoDataByToDoId?.change_inventory) {
      bookingTempList.push(...sales_constants, ...purchase_constants);
    }

    let todoTempList = [...todo_constants];
    if (bookingFieldList.length > 0) {
      bookingTempList.push(...bookingFieldList);
    }

    if (todoDataByToDoId?.based_on !== "Container" && todoFieldList.length > 0) {
      todoTempList.push(...todoFieldList);
    }

    if(todoDataByToDoId?.based_on === "Document"){
      bookingTempList = bookingTempList.filter(item => item.key !== "asset_tracking");
      todoTempList = todoTempList.filter(item => item.key !== "todo_tracking");
    }

    setBookingData(bookingTempList);
    setTodoData(todoTempList);
  }, [bookingFieldList, todoFieldList, todoDataByToDoId]);

  useEffect(() => {
    if(quillRefInstance.current && isOpen){
      quillRefInstance.current.clipboard.dangerouslyPasteHTML(0, emailData?.body ? emailData?.body : "");
    }
    return () => {
      quillRefInstance.current.clipboard.dangerouslyPasteHTML(0, "");
      if(quill) quill.setText("");
    }
  }, [emailData, isOpen])

  useEffect(() => {
    if(!quillRefInstance.current?.hasFocus() && !(document.activeElement === subjectRef.current)){
      setActiveField(null);
    }

    if(quillRefInstance.current?.hasFocus()){
      setActiveField("body");
    }
  }, [document.activeElement]);


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: defaultValues,
    onSubmit: (values) => {
      if (values.use_custom_notification && (!values.subject || !values.body)) {
        swal({
          content: (
            <CustomeModal
              type="warning"
              title="Warning!"
              content={"Subject and email body is required."}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        return;
      }
      values.body_obj.push(...body_ref.current)
      _handleSubmit(values);
      setIsOpen(false);
      setTodoAttachment(false);
      formik.resetForm();
      if(quill) quill.setText("")
    },
  });

  useEffect(() => {

    if (quill) {
        
      quillRefInstance.current = quill;
      const undoButton = document.querySelector(".ql-undo");
      const redoButton = document.querySelector(".ql-redo");
      if (undoButton) {
        undoButton.innerHTML = `<i class="fa-solid fa-rotate-left"></i>`;
        undoButton.onclick = () => quill.history.undo();
      }
      if (redoButton) {
        redoButton.innerHTML = `<i class="fa-solid fa-rotate-right"></i>`;
        redoButton.onclick = () => quill.history.redo();
      }

      quill.on('text-change', function () {
        formik.setFieldValue("body", quill.root.innerHTML);
      });

      quill.on('selection-change', function () {
        setTimeout(() => {
          quill.update();
        }, 50);
      });
    }
  }, [quill]);

  const handleItemClick = (data) => {
    if(activeField === "subject"){
      if(["asset_tracking", "todo_tracking"].includes(data.key)) return;
      const text = ` {{${data.key}}} `;
      const cursorPos = subjectRef.current.selectionStart;
      const textBefore = formik.values.subject.substring(0, cursorPos);
      const textAfter = formik.values.subject.substring(cursorPos);
      const newValue = textBefore + text + textAfter;
      formik.setFieldValue("subject", newValue);
      formik.setFieldValue("subject_obj", [...formik.values.subject_obj, data]);
      setTimeout(() => {
        subjectRef.current.selectionStart = subjectRef.current.selectionEnd = cursorPos + text.length;
        subjectRef.current.focus();
      }, 0);  
    } else if(activeField === "body"){
      const range = quillRefInstance.current.selection.savedRange;
      let mentionStart = range.index;
      const mentionText = `{{${data.key}}} `;
      quillRefInstance.current.insertText(mentionStart, mentionText);
      quillRefInstance.current.setSelection(mentionStart + mentionText.length);
      formik.setFieldValue("body_obj", [...formik.values.body_obj, data]);
    }


    // if (activeField === "subject") {
    //   formik.setFieldValue("subject", `${formik.values.subject} @${data.key}`);
    //   formik.setFieldValue("subject_obj", [...formik.values.subject_obj, data]);
    // } else if (activeField === "body") {
    //   formik.setFieldValue("body", `${formik.values.body} @${data.key}`);
    //   formik.setFieldValue("body_obj", [...formik.values.body_obj, data]);
    // }
  };

  const booking_list =
    search === ""
      ? bookingData
      : bookingData.filter((item) =>
          item.label.toLowerCase().includes(search.toLowerCase())
        );
  const todo_list =
    search === ""
      ? todoData
      : todoData.filter((item) =>
          item.label.toLowerCase().includes(search.toLowerCase())
        );

  return (
    <div>
      <div className="flex flex-row w-full h-full mt-5 space-x-4">
        {!formik.values.use_custom_notification && (
          <div
            title={"Please enable 'use custom notification' to create email composer."}
            className={`z-60 fixed w-full h-[calc(100vh-200px)] bg-gray-50 opacity-60 cursor-not-allowed`}
          ></div>
        )}

        {/* First Column */}
        <div className="w-4/12 h-[calc(100vh-200px)] p-3 bg-[--bg-color-50] rounded-md border border-[#E1E3E5] space-y-5 overflow-y-auto scrollbar scrollbar-w-1 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100">
          <p className="font-inter font-bold text-sm text-[#535860]">
            Available Components
          </p>
          <SearchForm
            placeholder="Search"
            onChange={(e) => {
              setSearch(e.target.value);
            }}
          />
          <div>
            <p className="font-inter font-bold text-sm text-[#535860] mb-4">
              Booking Data
            </p>
            {booking_list.map((item) => (
              <div
                key={item.key}
                className="flex flex-row items-center bg-white border border-gray-200 rounded-md px-3 py-2 space-x-3 mb-0.5 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  handleItemClick(item);
                }}
              >
                <i className={`${["asset_tracking", "todo_tracking"].includes(item.key) ? "fas fa-link" : "fa-solid fa-text"} text-[--bg-color-500]`}></i>
                <p className="font-inter font-semibold text-[13px] text-[#1E293B]">
                  {item.label}
                </p>
              </div>
            ))}
          </div>

          <div>
            <p className="font-inter font-bold text-sm text-[#535860] mb-4">
              To Do Data
            </p>
            {todo_list.map((item) => (
              <div
                key={item.key}
                className="flex flex-row items-center bg-white border border-gray-200 rounded-md px-3 py-2 space-x-3 mb-0.5 cursor-pointer"
                onClick={(e) => {
                  e.stopPropagation();
                  handleItemClick(item);
                }}
              >
                <i className={`${["asset_tracking", "todo_tracking"].includes(item.key) ? "fas fa-link" : "fa-solid fa-text"} text-[--bg-color-500]`}></i>
                <p className="font-inter font-semibold text-[13px] text-[#1E293B]">
                  {item.label}
                </p>
              </div>
            ))}
          </div>
        </div>

        {/* Second Column */}
        <div className="w-8/12 h-[calc(100vh-200px)] p-3 bg-[--bg-color-50] rounded-md border border-[#E1E3E5] space-y-4">
          <p className="font-inter font-bold text-sm text-[#535860]">
            Email Composer
          </p>

          <div className="w-full flex flex-row items-center space-x-5">
            <label
              htmlFor="subject"
              className="font-inter font-medium text-[13px] text-[#535860]"
            >
              Subject
            </label>
            <input
              ref={subjectRef}
              type="text"
              placeholder="Email subject"
              className={`w-full !h-[35px] form-input`}
              id="subject"
              value={formik.values.subject}
              onFocus={(e) => setActiveField("subject")}
              onChange={(e) => {
                e.stopPropagation();
                formik.setFieldValue("subject", e.target.value);
                // setSubject(e.target.value);
              }}
            />
          </div>
          <div className="h-[50%] xl:h-[60%] pb-6 xl:pb-3 xl:mb-5">
            <div ref={quillRef} onFocus={(e) => setActiveField("body")} style={{ height: '90%', background: "white" }} />
          </div>
          <div className={`w-full h-[130px] xl:h-[calc(100vh-720px)] 2xl:h-[calc(100vh-780px)] p-3 bg-white flex flex-col space-y-3 rounded-md border border-[#E1E3E5] overflow-y-auto scrollbar scrollbar-w-1 scrollbar-thumb-rounded-full scrollbar-track-rounded-full scrollbar-thumb-gray-300 scrollbar-track-gray-100`}
          >
            <p className="font-inter font-bold text-sm text-[#535860]">
              Attachments
            </p>
            <div>
              <label className="flex items-center">
                <input
                  type="checkbox"
                  className="form-checkbox"
                  checked={formik.values.attach_booking_documents}
                  onChange={(e) => {
                    formik.setFieldValue(
                      "attach_booking_documents",
                      e.target.checked
                    );
                  }}
                />
                <span className="text-sm font-medium ml-2">
                  Attach Booking / Order Files
                </span>
              </label>
            </div>
            {todoDataByToDoId?.activity_file_uploads?.length > 0 && (
              <div>
                <label className="flex items-center mb-2">
                  <input
                    checked={toodAttchment}
                    type="checkbox"
                    className="form-checkbox"
                    onChange={(e) => {
                      e.stopPropagation();
                      setTodoAttachment(!toodAttchment);
                      formik.setFieldValue("attach_todo_documents", []);
                    }}
                  />
                  <span className="text-sm font-medium ml-2">
                    Attach Todo Files
                  </span>
                </label>
                <div className="space-y-1">
                  {todoDataByToDoId?.activity_file_uploads.map((item) => (
                    <div
                      key={item.activity_file_upload_id}
                      className={`w-[240px] px-2 py-1 bg-[--bg-color-50] rounded-md border border-[#E1E3E5] `}
                    >
                      <label
                        className={`flex items-center ${
                          toodAttchment
                            ? "cursor-pointer"
                            : "cursor-not-allowed"
                        }`}
                      >
                        <input
                          type="checkbox"
                          className="form-checkbox"
                          checked={formik.values.attach_todo_documents.includes(
                            item.activity_file_upload_id
                          )}
                          onChange={(e) => {
                            e.stopPropagation();
                            if (toodAttchment) {
                              if (e.target.checked) {
                                formik.setFieldValue("attach_todo_documents", [
                                  ...formik.values.attach_todo_documents,
                                  item.activity_file_upload_id,
                                ]);
                              } else {
                                formik.setFieldValue("attach_todo_documents", [
                                  ...formik.values.attach_todo_documents.filter(
                                    (ele) =>
                                      ele !== item.activity_file_upload_id
                                  ),
                                ]);
                              }
                            }
                          }}
                        />
                        <span className="text-sm font-medium ml-2">
                          {item.file_name}
                        </span>
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>

      {/* button section */}
      <div className="w-full mt-4 flex flex-row justify-between items-center rounded-md border border-[#E1E3E5] bg-[--bg-color-50] px-4 py-2">
        <div className="w-full flex flex-row items-center space-x-2 ">
          <div className="form-switch">
            <input
              type="checkbox"
              checked={formik.values.use_custom_notification}
              onChange={(e) => {
                e.stopPropagation();
                formik.setFieldValue(
                  "use_custom_notification",
                  e.target.checked
                );
              }}
              id={"modal_checkbox"}
              className="sr-only"
            />
            <label htmlFor="modal_checkbox" className="bg-slate-400">
              <span className="bg-white shadow-sm" aria-hidden="true"></span>
            </label>
          </div>
          <p className="font-inter font-normal text-[13px] text-[#AEAEAE] capitalize">
            Use Custom Notification Form
          </p>
        </div>
        <div className="flex justify-end space-x-2 my-2">
          <button
            className="btn bg-white border-slate-200 hover:border-slate-300 text-slate-600"
            onClick={(e) => {
              e.preventDefault();
              setIsOpen(false);
              if(quill) quill.setText("");
            }}
          >
            Cancel
          </button>
          <button
            className="btn !bg-[--bg-color-500] hover:!bg-[--bg-color-600] text-white"
            type="button"
            onClick={(e) => {
              e.stopPropagation();
              formik.handleSubmit();
            }}
          >
            Save
          </button>
        </div>
      </div>
    </div>
  );
};

export default EmailComposer;
